/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-07-13 18:13:20
 * @LastEditors: xiawenlong
 * @LastEditTime: 2025-12-02 15:14:46
 */
export default {
  platformTotal: '/dashboard/get/platform/total', // 获取平台总计信息
  productSale: '/dashboard/get/product/sale/report', // 获取产品类型销售统计
  annualSaleAmount: '/dashboard/get/annual/sale/amount/report', // 获取本年度月销售额
  annualSaleQuantity: '/dashboard/get/annual/sale/quantity/report', // 获取本年度月销售数量
  areaSaleTotal: '/dashboard/get/area/sale/total', // 获取区域销售信息
  productLaunch: '/dashboard/get/product/launch/report', // 获取农产品上市列表
  buyerMonth: '/dashboard/get/buyer/month/report', // 获取农产品上市列表
  supplierSale: '/dashboard/get/supplier/sale/report', // 供应商月销售统计
  productionSaleTotal: '/dashboard/get/year/production/sale/total', // 成本与毛利统计
  freightReport: '/dashboard/get/freight/report', // 获取月货运量
  amountTotal: '/dashboard/get/platform/amount/total', // 获取平台总销售额
  plaformInfo: '/dashboard/get/platform/info', // 获取平台信息
  bszProductList: '/dashboard/baishazhou/product/list', // 白沙洲农产品报价列表
  onsaleMaterailPage: '/dashboard/onsale/material/page', // 在售商品列表
  groupMaterialPage: '/dashboard/group/material/page', // 校园餐采购订单列表
  userCusPage: '/dashboard/user/cus/page', // 个人用户列表
  bizCusPage: '/dashboard/biz/cus/page', // 企业客户列表
  bizSupplierPage: '/dashboard/biz/supplier/page', // 供应商列表
  userOrderPage: '/dashboard/user/order/page', // 零售订单列表
  groupOrderPage: '/dashboard/group/order/page', // 校园餐采购订单列表
  bizOrderPage: '/dashboard/biz/order/page', // 企业订单列表
  getAreaSaleTotalDetail: '/dashboard/get/area/sale/total/detail', // 企业订单列表
  areaCompanyList: '/dashboard/area/company/list', // 镇办下属农村集体经济组织
  areaCompanyProduct: '/dashboard/area/company/product/page', // 镇办下属农村集体经济组织商品列表
  areaCompanyOrder: '/dashboard/area/company/order/page', // 镇办下属农村集体经济组织订单列表
  customerPurchaseRank: '/group/customer/purchase/rank', // 客户采购金额排行
  materialSalePricePage: '/group/purchase/material/sale/price/page', // 团餐商品销售总价分页查询
  thirdOrderPage: '/dashboard/third/order/page', // 第三方订单列表
  dashboardLogin: '/dashboard/login', // 大屏登录
  dashboardCheckToken: '/dashboard/check/token', // 校验大屏token是否有效
}
